import { useState } from "react";
import Swal from "sweetalert2";
import Select from "react-select";
const EnquiryForm = ({ countries = [] }) => {
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    email: "",
    weight: "",
    country: "All Country",
  });
  const countryOptions = countries.map((c) => ({
    label: c,
    value: c,
  }));
  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "name") {
      value = value.replace(/[^a-zA-Z ]/g, "").replace(/^\s+|\s{2,}/g, " ");
    }

    if (name === "number") {
      value = value.replace(/[^0-9]/g, "").slice(0, 10);
    }
    if (name === "weight") {
      value = value
        .replace(/[^0-9.]/g, "")
        .replace(/(\..*?)\..*/g, "$1")
        .slice(0, 10);
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email && !formData.number) {
      Swal.fire("Error", "Email ya phone number do", "error");
      return;
    }

    if (
      formData.number &&
      !/^[987]\d{9}$/.test(formData.number)
    ) {
      Swal.fire("Error", "Invalid phone number", "error");
      return;
    }

    const formURL =
      "https://docs.google.com/forms/d/e/1FAIpQLSe3lVOpUJnBnRe65VlTSZkzLYnvJvpuxvVeC21IAYSh9CtJcQ/formResponse";

    const fd = new FormData();

    fd.append("entry.1436625964", formData.name);
    fd.append("entry.1884680719", formData.number);
    fd.append("entry.1180525227", formData.email); 
    fd.append("entry.1162928954", formData.weight);
    fd.append("entry.1915080044", formData.country);

    await fetch(formURL, {
      method: "POST",
      mode: "no-cors",
      body: fd,
    });

    setFormData({
      name: "",
      number: "",
      email: "",
      weight: "",
      country: "All Country",
    });

    Swal.fire({
      title: "Form Submitted!",
      text: "Thank you! Your details have been submitted successfully. We’ll get back to you shortly.",
      icon: "success",
      timer: 2000,
      showConfirmButton: false,
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-md-6 mb-3">
          <label>Full Name <span>*</span></label>
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="form-control"
            required
            placeholder="e.g. Rohit Sharma"
          />
        </div>

        <div className="col-md-6 mb-3">
          <label>Contact Number <span>*</span></label>
          <input
            name="number"
            value={formData.number}
            onChange={handleChange}
            className="form-control"
            required
            placeholder="e.g. 9876543210"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 mb-3">
          <label>Weight <span>*</span></label>
          <input
            name="weight"
            required
            value={formData.weight}
            onChange={handleChange}
            className="form-control"
            placeholder="e.g. 70 kg"
          />
        </div>

        <div className="col-md-6 mb-3">
          <label>Country</label>
          <Select
          options={countryOptions}
          value={countryOptions.find(opt => opt.value === formData.country)}
          onChange={(selected) =>
            setFormData({ ...formData, country: selected.value })
          }
          placeholder="Search country"
          className="search-input"
          />
            {/* {(countries || []).map((c, i) => (
              <option key={i} value={c}>
                {c}
              </option>
            ))}
          </select> */}
        </div>
      </div>

      <button className="btn btn-primary">Submit <i className="fas fa-arrow-right"></i></button>
    </form>
  );
};

export default EnquiryForm;